<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				外出申请-{{ruleForm.id != null && ruleForm.id != '' ? '修改' : '新增'}}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>

			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
				<!-- 查询框 -->
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
					<el-row>
						<el-col :span="12">
							<div @click="txbm()">
								<el-form-item label="姓名" prop="staff_name" style="margin-top:80px;width:80%">
									<el-input style="width:595px" v-model="ruleForm.staff_name"></el-input>
								</el-form-item>
							</div>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="开始时间" prop="start_date">
								<el-date-picker v-model="ruleForm.start_date" style="width:595px" type="datetime"
									format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="结束时间" prop="end_date">
								<el-date-picker v-model="ruleForm.end_date" style="width:595px" type="datetime"
									format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="外出时间(小时)" prop="travel_duration" style="width:80%">
								<el-input type="text" v-model="ruleForm.travel_duration" style="width:595px"
									placeholder="请输入外出时间">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="外出事由" prop="travel_reason">
								<el-input type="textarea" :rows="2" style="width:595px" placeholder="请输入代岗原因"
									v-model="ruleForm.travel_reason">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="照片" prop="name">
								<el-upload :action="$globals.http + '/file/upload'" list-type="picture-card"
									:on-preview="handlePictureCardPreview" :limit="1" :on-remove="handleRemove"
									:on-success="handleAvatarSuccess">
									<i class="el-icon-plus"></i>
								</el-upload>
								<el-dialog :visible.sync="dialogVisible">
									<img width="100%" :src="ruleForm.bank_photo" alt="">
								</el-dialog>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item style="margin-left:200px">
						<el-button type="goon" @click="Add" v-show="ruleForm.id == null || ruleForm.id == ''">保存
						</el-button>
						<el-button type="goon" @click="UpdateAuditor" v-show="ruleForm.id != null && ruleForm.id != ''">
							修改
						</el-button>
						<el-button type="addbtn" @click="resetForm('ruleForm')">重置</el-button>
					</el-form-item>
				</el-form>

			</div>

		</div>
		<el-dialog title="选择外出人" :visible.sync="dialogVisibles" width="40%" :center="true" :close-on-click-modal="false"
			:show-close="false">
			<el-row>
				<organizeStaff ref="organizeStaff" type="radio" :accordion="false" @commit="saveChange"
					:staff_id_prop="ruleForm.staff_ids"></organizeStaff>
			</el-row>
			<el-row style="text-align: center;">
				<el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
			</el-row>
		</el-dialog>

		<!-- <el-dialog title="选择审核人" :visible.sync="dialogAuditorVisible" width="40%" :center="true"
			:close-on-click-modal="false">
			<SelectAuditor ref="SelectAuditor" :type="6" :examineDetailsList="ruleForm.examineDetailsList"
				:id="ruleForm.id"></SelectAuditor>
		</el-dialog> -->
	</div>
</template>

<script>
	import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
	import SelectAuditor from '../SelectAuditor/SelectAuditor.vue';
	export default {
		components: {
			organizeStaff: organizeStaff,
			SelectAuditor: SelectAuditor,
		},
		props: ["organizeList"],
		data() {
			return {
				//页面相关
				dialogVisibles: false,
				dialogVisible: false,
				dialogAuditorVisible: false,
				dialogImageUrl: '',

				//表单数据
				ruleForm: {
					id: '',
					staff_id: '',
					staff_name: '',
					start_date: '',
					end_date: '',
					travel_duration: '',
					travel_reason: '',
					travel_url: '',
					travel_duration: '',
					examineDetailsList: [],
				},

				//暂存数据
				object: {
					staff_id: "",
					staff_name: "",
					project_id: "",
					project_name: ""
				},

				//表单验证
				rules: {
					staff_name: [{
						required: true,
						message: '请选择用户！',
						trigger: 'blur'
					}],
					dictionaries_id: [{
						required: true,
						message: '请选择请假类型',
						trigger: 'blur'
					}],
					start_date: [{
						required: true,
						message: '请输选择开始时间',
						trigger: 'blur'
					}],
					end_date: [{
						required: true,
						message: '请选择结束时间',
						trigger: 'blur'
					}],
					travel_duration: [{
						required: true,
						message: '请输入外出时长',
						trigger: 'blur'
					}],
					travel_reason: [{
						required: true,
						message: '请输入外出事由',
						trigger: 'blur'
					}],
				},
			};
		},
		methods: {
			txbm() {
				this.dialogVisibles = true;
				this.showtxbm = true;
			},
			//设置确定
			saveChange(e) {
				this.ruleForm.staff_id = e.staff_id;
				this.ruleForm.staff_name = e.staff_name;
				this.dialogVisibles = false;
			},
			handleAvatarSuccess(res, file) {
				this.ruleForm.travel_url = res.data.fileUrl;
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			Return() {
				this.dialogAuditorVisible = false;
				this.$parent.Return();
				this.$parent.Find();
				this.trash();
			},
			//添加
			AddAuditor() {
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.ruleForm.examineDetailsList = [];
						this.dialogAuditorVisible = true;
						this.$refs['SelectAuditor'].initialize();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async Add() {
				var url = 'StaffTravel/insert';
				var record = {
					staff_id: this.ruleForm.staff_id,
					start_date: this.ruleForm.start_date,
					end_date: this.ruleForm.end_date,
					travel_duration: this.ruleForm.travel_duration,
					travel_reason: this.ruleForm.travel_reason,
					travel_url: this.ruleForm.travel_url,
					travel_duration: this.ruleForm.travel_duration,
					examineDetailsList: this.ruleForm.examineDetailsList,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						// this.Find();
						this.Return();
						return this.$globals.user.id;
					} else {
						this.$message.warning(data);
					}
				}
			},
			//修改
			UpdateAuditor() {
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.ruleForm.examineDetailsList = [];
						this.dialogAuditorVisible = true;
						this.$refs['SelectAuditor'].initialize();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async Update() {
				var url = 'StaffTravel/update';
				var record = {
					id: this.ruleForm.id,
					staff_id: this.ruleForm.staff_id,
					start_date: this.ruleForm.start_date,
					end_date: this.ruleForm.end_date,
					travel_duration: this.ruleForm.travel_duration,
					travel_reason: this.ruleForm.travel_reason,
					travel_url: this.ruleForm.travel_url,
					travel_duration: this.ruleForm.travel_duration,
					examineDetailsList: this.ruleForm.examineDetailsList,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Return();
						return this.$globals.user.id;
					} else {
						this.$message.warning(data);
					}
				}
			},
			//清除数据
			trash() {
				this.ruleForm.id = '';
				this.ruleForm.start_date = '';
				this.ruleForm.start_id = '';
				this.ruleForm.staff_name = '';
				this.ruleForm.end_date = '';
				this.ruleForm.travel_duration = '';
				this.ruleForm.travel_reason = '';
				this.ruleForm.travel_url = '';
				this.ruleForm.applicant_id = '';
				this.ruleForm.examineDetailsList = [];
			},
		},
		created() {
			this.ruleForm = this.$parent.ruleForm;
		},
		watch: {
			"ruleForm.staff_id"(newValue) {
				this.object.staff_id = newValue;
			},
			"ruleForm.staff_name"(newValue) {
				this.object.staff_name = newValue;
			},
		}
	};
</script>

<style>
</style>



// WEBPACK FOOTER //
// Wcsq_add.vue?97af1a76